import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { setStoreItem } from '~/utilities/Store';
import { LAST_LOADED } from '~/constants/LAST_LOADED';
import SportradarFactory from '~/components/Shared/Sportradar/SportradarFactory';
import { SPORTRADAR_NAMES } from '~/constants/SPORTRADAR';
import { tickerCallback } from '~/utilities/elements/buildSportradar';

// on home page
export default component$((): JSX.Element => {
  setStoreItem(LAST_LOADED, 'SportradarTicker');

  return (
    <SportradarFactory
      name={SPORTRADAR_NAMES.TICKER}
      sportradarProps={{
        // TODO: this should come from the payload
        sport: 'nba',
        onItemClick: tickerCallback.toString(),
      }}
      wrapperClass='bg-white w-full h-[61px] border-b border-b-lightGrey mb-10 md:mb-5 !p-0'
    />
  );
});
